/* import __COLOCATED_TEMPLATE__ from './index.hbs.js'; */
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == typeof i ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != typeof t || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != typeof i) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
import { get } from "@ember/object";
import Component from "@glimmer/component";
import { BufferedChangeset } from "ember-changeset/types";
export const STYLES = {
  "error-validated-input-display": "mt-[0.2rem] text-right",
  "right-aligned-validation-error-message": "mt-[0.2rem] absolute right-[0]",
  "left-aligned-validation-error-message": "mt-[0.2rem] text-left",
  "error-validated-checkbox-display": "mt-[2px] ml-[26px]"
};
export default class ValidatedField extends Component {
  constructor(...args) {
    super(...args);
    // @ts-expect-error Since this.args.errorClass is optional, this implementation needs to be updated
    _defineProperty(this, "styles", `text-[#d55742] _${this.args.errorClass} ${STYLES[this.args.errorClass]}`);
  }
  // Even if there are multiple errors related to `this.propertyName`, we show only one validation at a time
  // (a validation describes what was wrong with the value set on the changeset)
  get validation() {
    if (!this.args.propertyName || !this.args.changeset) return;
    const error = get(this.args.changeset.error, this.args.propertyName);
    if (!error) return undefined;
    return Array.isArray(error.validation) ? error.validation[0] : error.validation;
  }
}